import React, {
  createContext,
  useState,
  useContext,
  useCallback,
  useRef,
} from "react";

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const lastCallTimestamp = useRef(0);
  const debounceDelay = 100; // 100ms debounce delay

  const showMenu = useCallback((items, x, y) => {
    const now = Date.now();
    if (now - lastCallTimestamp.current > debounceDelay) {
      lastCallTimestamp.current = now;

      const defaultItems = [];
      const combinedItems = items.concat(defaultItems);

      setMenuItems(combinedItems);
      setMenuPosition({ x, y });
      setIsMenuVisible(true);
    }
  }, []);

  const hideMenu = useCallback(() => {
    setIsMenuVisible(false);
  }, []);

  return (
    <MenuContext.Provider
      value={{ menuItems, menuPosition, isMenuVisible, showMenu, hideMenu }}
    >
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
